<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em !important;">RG was born and raised in the South, with ancestral roots dating back to the 1800s. A passion for the written word, who believes one’s hard work will ultimately provide the success and rewards. The 40 years of airline experience are the catalyst for his stories.</p><br/>
<p style="text-indent:0em !important;">“We all strive to do better and to reach the goals we have set for ourselves. We do what we can with the resources we have been given. I have been presented with an opportunity and with the Lord’s direction and help, I am confident of my success.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7ab7f8b0